import { render, staticRenderFns } from "./ComponentTypeTeaser.vue?vue&type=template&id=5d87d440&scoped=true&"
import script from "./ComponentTypeTeaser.vue?vue&type=script&lang=js&"
export * from "./ComponentTypeTeaser.vue?vue&type=script&lang=js&"
import style0 from "./ComponentTypeTeaser.vue?vue&type=style&index=0&id=5d87d440&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d87d440",
  null
  
)

export default component.exports